import React from "react";
import { AuthProvider } from "./src/features/auth/AuthContext";
import "./src/styles/global.css";

export function wrapRootElement({ element }) {
  return <AuthProvider>{element}</AuthProvider>;
}
